import { render, staticRenderFns } from "./viewBus.vue?vue&type=template&id=e7f22c00"
import script from "./viewBus.vue?vue&type=script&lang=js"
export * from "./viewBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports